/* eslint-disable no-shadow */
import NProgress from 'nprogress/nprogress';
import api from './api';

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  /**
   * Creates a new contact (the BE will send an email message with sendgrid).
   *
   * @params {Object} options - { name, email, subject, message }
   * @return {Promise}
   */
  contact(_, options) {
    NProgress.start();

    return api.Landing.contact(options)
      .then(() => Promise.resolve())
      .finally(() => {
        NProgress.done();
      });
  },
};
